import { IconProps, NocIconGenerator } from '../common';

export const Polygon = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'Polygon',
            path: (
                <>
                    <path
                        d="M12 12.1008L7.5 14.7008L3 12.1008V6.90078L7.5 4.30078L12 6.90078V8.50078"
                        stroke="#292d32"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 12.1L16.5 9.5L21 12.1V17.3L16.5 19.9L12 17.3V15.6"
                        stroke="#292d32"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </>
            ),
        }}
    />
);
